export default __webpack_public_path__ + "static/media/harris-hawk.3e53216a.jpg";